export const customJs = (customJS, clientEventParams) => {
  const customScript = document.createElement('script');
  if (customJS.indexOf('dataLayer.push') > -1) {
    if (window.dataLayer) {
      // This is an example for GTM, where we make sure the dataLayer is available before pushing the event.
      customScript.innerHTML = customJS.replace(/\(([^)]+)\)/, `(${JSON.stringify(clientEventParams)})`);
    }
  }
  else {
    customScript.innerHTML = customJS;
  }
  document.body.appendChild(customScript);
}

